import { getGradientColors, isGradientColor } from '$lib/components/Blocks/_utils/color';

import Color from 'color';

export const getResponseBgColor = (refColor: string) => {
    const isGradient = isGradientColor(refColor);
    const color = isGradient ? getGradientColors(refColor)[0] : refColor;

    return Color(color).lightness() >= 40 ? 'fun-bg-black/15' : 'fun-bg-white/15';
};
